<template>
  <div v-if="$store.state.roles.includes('dbadmin')" v-loading="$store.state.loading">

    <el-tabs type="card" v-model="component">
      <el-tab-pane label="自定义数据库" name="defineddb">自定义数据库上传与定义</el-tab-pane>
      <el-tab-pane label="已定义数据库" name="existingdb">已定义数据库上传</el-tab-pane>
      <!-- <el-tab-pane label="数据库导出" name="dbtoexcel">数据库导出至excel</el-tab-pane> -->
       <!-- <el-tab-pane label="权限管理" name="collectionsetting">数据库权限设置与管理</el-tab-pane> -->
       <el-tab-pane v-if="$store.state.roles.includes('superadmin')" label="备份" name="backup">备份</el-tab-pane>
       <el-tab-pane v-if="$store.state.roles.includes('superadmin')" label="数据库更新" name="multiclcsupdate">数据库更新</el-tab-pane>
       <el-tab-pane v-if="$store.state.roles.includes('superadmin')" label="LISTFILES" name="listfiles">Listfiles</el-tab-pane>
       <el-tab-pane v-if="$store.state.roles.includes('superadmin')" label="Touploadzipfile" name="touploadzipfile">Touploadzipfile</el-tab-pane>
    </el-tabs>
    <br>
    <component :is="component"></component>
  </div>
</template>
<script>
import defineddb from "./defineddb";
import existingdb from "./existingdb";
// import dbtoexcel from "./dbtoexcel";
// import collectionsetting from "./collectionsetting";
import backup from "./backup";
import multiclcsupdate from "./multiclcsupdate"
import listfiles from "./listfiles"
import touploadzipfile from "./touploadzipfile"
export default {
  components: { defineddb, existingdb,backup,multiclcsupdate,listfiles,touploadzipfile},
  data() {
    return {
      component: "defineddb"
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/exceltodb/index.vue